<template>
  <div v-if="jobsList && jobsList.length > 0" class="dashboard-jobs-list-container">
    <div class="jobs-list-heading-container">
      <div class="heading">{{ jobHeading }}</div>
      <div class="all-jobs-link" @click="$emit('backToJobs', 'Jobs')">View All Jobs</div>
    </div>

    <div class="jobs-list-body"
      v-bind:class="{
        'lesser-jobs': jobsList.length < 3,
        'even-jobs': jobsList.length === 4,
        'large-jobs': jobsList.length >= 5
        }"
    >
      <div class="job-item" v-for="job in jobsList" v-bind:key="job && job.id" @click="viewJob(job && job.id)">
      <!-- <div class="job-item" v-for="(job, index) in jobsList" :key="index" @click="viewJob(job && job.id)"> -->
        <div class="job-name">{{job && job.title}}</div>
        <div class="job-location" v-if="(job && job.city) && (job && job.state)">{{job.city}}, {{job.state}}</div>
        <!-- <div class="job-company-name" v-if="(job && job.companyName) || (userData && userData.companyName)">Company: <span>{{job.companyName || userData.companyName}}</span></div> -->
        <div class="job-company-name" v-if="(job && job.companyName) || (userData && userData.companyName)"><span>{{job.companyName || userData.companyName}}</span></div>
        <div
          v-if="job && job.status === 'Active'"
          class="job-status"
        >
          <!-- Status: -->
          <span class="status-active">{{job.status}}</span>
        </div>
        <div
          v-if="job && job.status === 'Closed'"
          class="job-status"
        >
          <!-- Status: -->
          <span class="status-closed">{{job.status}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardJobsList',
  props:[
    'jobsList',
    'jobHeading',
    'userType',
    'userData'
  ],
  data () {
    return {
      user: this.userType
    };
  },
  methods: {
    viewJob (id) {
      if(id === undefined) {return;}
      this.user === 'normal-user' ? this.$emit('applicantJobView', id) : this.$emit('creatorJobView', id);
    }
  }
};
</script>

<style scoped>
  .dashboard-jobs-list-container {
    width:100%;
    height:100%;
    display:grid;
    grid-template-rows: 80px auto;
  }
  .dashboard-jobs-list-container .jobs-list-heading-container {
    border-radius:15px 15px 0 0;
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:0 2.75rem;
    background: rgba(27, 36, 72, 0.04);
  }

  .jobs-list-heading-container .heading {
    font-size:1.15rem;
    color:#071A52;
    font-weight:600;
    line-height:1.524rem;
  }

  .jobs-list-heading-container .all-jobs-link {
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    height:3.380rem;
    font-weight:bold;
    font-size:0.9rem;
    text-decoration:underline;
    cursor: pointer;
    color:var(--colorPrimary);
  }

  /* .all-jobs-link a {
    color:var(--colorSecondary);
  } */
  .dashboard-jobs-list-container .jobs-list-body {
    display:grid;
    /* grid-template-columns: 1fr 1fr 1fr; */
    /* grid-template-rows: 1fr 1fr; */
  }
  .lesser-jobs {
    display: grid;
    grid-template-columns: 1fr;
  }
  .even-jobs {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .large-jobs {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .jobs-list-body .job-item {
    text-transform: capitalize;
    display:flex;
    justify-content:space-evenly;
    flex-direction:column;
    padding:1.5rem 2.75rem;
    border-bottom: 1px solid rgba(196, 196, 196, 0.5);
    cursor: pointer;
  }
  .jobs-list-body .job-item:hover {
    background-color: rgba(2, 95, 160, 0.15);
  }
  .job-item:nth-child(2),
  .job-item:nth-child(even),
  .job-item:nth-child(5) {
    border-left: 1px solid rgba(196, 196, 196, 0.5);
    border-right: 1px solid rgba(196, 196, 196, 0.5);
  }

  .job-item .job-name {
    font-size:1.1rem;
    font-weight: 700;
    color: var(--black);
    line-height: 1.8rem;
    text-transform: capitalize;
  }

  .job-item .job-location {
    font-weight: 500;
    color: #828282;
    line-height: 1.7rem;
    font-size: 0.85rem;
  }

  .job-item .job-company-name {
    /* margin-top: 0.625rem; */
    margin-top: 1.25rem;
    font-size: 0.9rem;
  }

  .job-item .job-company-name,
  .job-item .job-status {
    color:#828282;
    font-weight:bold;
    line-height: 1.6rem;
  }

  .job-item .job-status {
    font-size: 0.85rem;
  }

  .job-company-name span {
    color:#252525;
    font-weight: 800;
  }

  .status-active {
    color:#27AE60;
  }

  .status-closed {
    color:#df2029;
  }

  .job-item span {
    /* margin-left: 0.55rem; */
    margin-left: 0;
  }

  @media only screen and (max-width: 1200px) {
    .dashboard-jobs-list-container .jobs-list-heading-container {
      padding: 0 1.75rem;
    }

    .jobs-list-body .job-item {
      padding: 1rem 1rem 1rem 1.75rem;
    }

    .job-item .job-name {
      font-size:calc(1.1rem/1.2);
    }

    .job-item .job-location {
      font-size:calc(1rem/1.2);
    }

    .job-item .job-company-name,
    .job-item .job-status {
      font-size:calc(1.25rem/1.5);
    }
  }

  @media only screen and (max-width: 767px) {
    .dashboard-jobs-list-container .jobs-list-body {
      display:grid;
      grid-template-columns: 1fr 1fr ;
      grid-template-rows: auto;
    }

    .job-item:nth-child(3) {
      border-right: 1px solid rgba(196, 196, 196, 0.5);
    }
  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {
    .jobs-list-heading-container {
      flex-direction: column;
      padding: 0.5rem 0.75rem !important;
    }
  }

</style>
